import { Moment } from 'moment'

export function convertNumberToCommaSeperated(number: number) {
  return number
    .toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function getMomentDateDiff(start: Moment, end: Moment) {
  return end.diff(start, 'days') + 1
}

export function camelToSnakeCase(str: string) {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function normFile(e: any) {
  if (Array.isArray(e)) {
    return e
  }
  return e?.fileList
}

export function getFileId(url: string) {
  const splitted = url.split('/')
  return splitted[splitted.length - 1].replace('.csv', '')
}

export const formatMomentToApiDate = (momentDate: Moment) =>
  momentDate.format('YYYY-MM-DD HH:mm:ss')
